import {ThirdParty} from '../../../../lib/third_party/types';
// TODO Figure out where to import udExternalLoaders from
// import {udExternalLoaders} from '@udemy-v2/ud-external-loaders';

interface ShareContext {
    shareableText?: string;
    title?: string;
}

interface ShareActions {
    showImportEmailModal: () => void;
    showCopyText: () => void;
}

// NOTE This assumes that the third_party object will be loaded from a separate API call
export function createNetworkShareBehaviors(third_party: ThirdParty) {
    return {
        facebook: (shareTarget: string) => {
            // TODO Figure out how to load the Facebook SDK
            // udExternalLoaders.loadFacebookSDK(() => {
            window.FB.init({
                appId: third_party.facebook_app_id,
                autoLogAppEvents: true,
                xfbml: true,
                version: 'v2.11',
            });
            window.FB.ui({
                method: 'share',
                app_id: third_party.facebook_app_id,
                display: 'iframe',
                href: shareTarget,
                redirect_uri: shareTarget,
            });
            // });
        },
        fb_workplace: (shareTarget: string) => {
            const url = `https://work.facebook.com/sharer.php?display=popup&u=${shareTarget}`;
            const options = 'toolbar=0,status=0,resizable=1,width=626,height=436';
            window.open(url, 'sharer', options);
        },
        twitter: (shareTarget: string, context: ShareContext) => {
            const twitterBoxWidth = 550;
            const twitterBoxHeight = 420;
            const twitterBoxLeft = window.innerWidth / 2 - twitterBoxWidth / 2;
            const twitterBoxTop = window.innerHeight / 2 - twitterBoxHeight / 2;
            const windowParams = `scrollbars=yes,resizable=yes,toolbar=no,location=yes,
            width=${twitterBoxWidth},height=${twitterBoxHeight}, left=${twitterBoxLeft},
            top=${twitterBoxTop}`;
            window.open(
                `https://x.com/intent/post?text=${encodeURIComponent(
                    context.shareableText || '',
                )}&url=${encodeURIComponent(shareTarget)}`,
                'intent',
                windowParams,
            );
        },
        mailto: (shareTarget: string, context: ShareContext) => {
            const emailBody = `${context.shareableText}\n${shareTarget}`;
            window.location.href = `mailto:?subject=${encodeURIComponent(
                context.title || '',
            )}&body=${encodeURIComponent(emailBody)}`;
        },
        mail_ref: (shareTarget: string, context: ShareContext, actions: ShareActions) => {
            actions.showImportEmailModal();
        },
        clipboard: (shareTarget: string, context: ShareContext, actions: ShareActions) => {
            actions.showCopyText();
        },
        'facebook-messenger': (shareTarget: string) => {
            const appId = third_party.facebook_app_id;
            window.open(
                `fb-messenger://share?link=${encodeURIComponent(
                    shareTarget,
                )}&app_id=${encodeURIComponent(appId)}`,
                'messenger',
            );
        },
        whatsapp: (shareTarget: string, context: ShareContext) => {
            const url = `https://wa.me?text=${encodeURIComponent(
                `${context.shareableText}\n${shareTarget}`,
            )}`;
            window.open(url);
        },
    };
}
